import BillingListPage from '@module-tenant/billing/BillingListPage';
import DeliveryTripDetailListPage from '@module-tenant/driver/deliveryTrip/DeliveryTripDetailListPage';
import DeliveryTripListPage from '@module-tenant/driver/deliveryTrip/DeliveryTripListPage';
import DriverListPage from '@module-tenant/driver/DriverListPage';
import EmployeeListPage from '@module-tenant/employee/EmployeeListPage';
import IngredientsListPage from '@module-tenant/ingredients/IngredientsListPage';
import FoodListPage from '@module-tenant/menu/food/FoodListPage';
import MenuListPage from '@module-tenant/menu/MenuListPage';
import OrderListPage from '@module-tenant/order/OrderListPage';
import HappyHourPage from '@module-tenant/settings/happyHour/HappyHourPage';
import KitplayDeviceTabPage from '@module-tenant/settings/kitplayDevice';
import RestaurantStoreSitePage from '@module-tenant/settings/order/RestaurantStoreSitePage';
import RestaurantPickUpDisplayLivePage from '@module-tenant/settings/pickUpDisplay/RestaurantPickUpDisplayLivePage';
import RestaurantPrinterPage from '@module-tenant/settings/printer/RestaurantPrinterPage';
import RestaurantQrCodeLivePage from '@module-tenant/settings/qrcodelive/RestaurantQrCodeLivePage';
import TableSettingPage from '@module-tenant/settings/table/TableSettingPage';
import BeilageTemplateListPage from '@module-tenant/template/BeilageTemplateListPage';
import VoucherRedemptionListPage from '@module-tenant/voucher/redemption/VoucherRedemptionListPage';
import VoucherListPage from '@module-tenant/voucher/VoucherListPage';
import GeneralSettingPage from '@modules/setting/GeneralSettingPage';

const tenantRoutes = {
    menuListPage: {
        path: '/:restaurantId/menu',
        component: MenuListPage,
        auth: true,
        title: 'MenuListPage',
    },
    menuFoodListPage: {
        path: '/:restaurantId/menu/foods',
        component: FoodListPage,
        auth: true,
        title: 'FoodListPage',
    },
    menuComboFoodListPage: {
        path: '/:restaurantId/menu/foods/:parentId',
        component: FoodListPage,
        auth: true,
        title: 'FoodListPage',
    },
    employeeListPage: {
        path: '/:restaurantId/employee',
        component: EmployeeListPage,
        auth: true,
        title: 'EmployeeListPage',
    },
    driverListPage: {
        path: '/:restaurantId/driver',
        component: DriverListPage,
        auth: true,
        title: 'DriverListPage',
    },
    beilageTemplateListPage: {
        path: '/:restaurantId/beilages',
        component: BeilageTemplateListPage,
        auth: true,
        title: 'MenuListPage',
    },
    generalListPage: {
        path: '/:restaurantId/setting',
        component: GeneralSettingPage,
        auth: true,
        title: 'GeneralSettingPage',
    },
    listPrinterSettingsPage: {
        path: '/:restaurantId/printer',
        component: RestaurantPrinterPage,
        auth: true,
        title: 'Printer settings page',
    },
    listHappyHourSettingsPage: {
        path: '/:restaurantId/happy-hour',
        component: HappyHourPage,
        auth: true,
        title: 'Happy hour settings page',
    },
    listPickUpDisplaySettingsPage: {
        path: '/:restaurantId/pick-up-display',
        component: RestaurantPickUpDisplayLivePage,
        auth: true,
        title: 'ReadyBoard settings page',
    },
    listQRCodeLiveSettingsPage: {
        path: '/:restaurantId/qrcode-live',
        component: RestaurantQrCodeLivePage,
        auth: true,
        title: 'QR code live settings page',
    },
    listTableSettingsPage: {
        path: '/:restaurantId/table',
        component: TableSettingPage,
        auth: true,
        title: 'Table settings page',
    },
    listOrderSettingsPage: {
        path: '/:restaurantId/order',
        component: RestaurantStoreSitePage,
        auth: true,
        title: 'Order settings page',
    },
    listKitplaySettingsPage: {
        path: '/:restaurantId/kitplay',
        component: KitplayDeviceTabPage,
        keyActiveTab: 'activeKitplayDeviceTab',
        auth: true,
        title: 'Kitplay settings page',
    },
    driverDeliveryTripListPage: {
        path: '/:restaurantId/driver/:driverId/delivery-trip',
        component: DeliveryTripListPage,
        auth: true,
        title: 'DeliveryTripListPage',
    },
    driverDeliveryTripDetailListPage: {
        path: '/:restaurantId/driver/:driverId/delivery-trip/:deliveryTripId',
        component: DeliveryTripDetailListPage,
        auth: true,
        title: 'DeliveryTripDetailListPage',
    },
    orderListPage: {
        path: '/:restaurantId/order-list',
        component: OrderListPage,
        auth: true,
        title: 'OrderListPage',
    },
    billingListPage: {
        path: '/:restaurantId/billing',
        component: BillingListPage,
        auth: true,
        title: 'BillingListPage',
    },
    ingredientsListPage: {
        path: '/:restaurantId/ingredients',
        component: IngredientsListPage,
        auth: true,
        title: 'Ingredients list page',
    },
    voucherListPage: {
        path: '/:restaurantId/voucher',
        component: VoucherListPage,
        auth: true,
        title: 'VoucherListPage',
    },
    voucherRedemptionListPage: {
        path: '/:restaurantId/voucher/redemption',
        component: VoucherRedemptionListPage,
        auth: true,
        title: 'VoucherRedemptionListPage',
    },
};

export default tenantRoutes;
